<template>
  <layout-with-back-btn title="Detail Fulfillment">
    <div
      v-if="loading"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <b-spinner
        v-if="loading"
        variant="primary"
      />
      <p class="mb-0">
        Memuat data...
      </p>
    </div>
    <div
      v-else-if="isError"
      class="mx-[20px] flex items-center justify-center gap-[10px]"
    >
      <p class="mb-0">
        Gagal mengambil data, silahkan coba lagi.
      </p>
    </div>
    <div v-else>
      <div class="text-black m-[20px]">
        <detail-row title="No. Order">
          <div class="flex items-center gap-[8px]">
            <img
              :src="marketplaceLogo"
              alt="marketplace"
              width="16"
            >
            <p>{{ data.marketplace_order_id || '-' }}</p>
          </div>
        </detail-row>
        <detail-row title="Mitra Gudang">
          <div>
            <p>{{ data.warehouse_name || '-' }}</p>
          </div>
        </detail-row>
        <detail-row title="Batas Pickup">
          <div>
            <p>{{ pickupDeadline }}</p>
          </div>
        </detail-row>
        <detail-row title="Label Pengiriman">
          <div class="flex items-center py-[2px] gap-[10px]">
            <b-button
              v-if="data.awb"
              variant="ghost"
              class="!text-black !font-normal hover:!underline transition-all duration-300 !p-0 !flex items-center gap-[4px]"
              :disabled="isPrintingOrder"
              @click="requestPrintOrder"
            >
              <b-spinner
                v-if="isPrintingOrder"
                variant="primary"
                small
              />
              <span
                v-else
                class="k-document-download"
              />
              {{ data.awb }}
            </b-button>
            <p
              v-else
              class="text-black"
            >
              -
            </p>
          </div>
        </detail-row>
        <detail-row title="Status">
          <StatusOrderPill
            :status="data.status"
            :mapping="statusMapping"
          />
        </detail-row>
      </div>

      <detail-order :data="data" />
    </div>
    <modal-loading-download ref="modalLoadingDownload" />
  </layout-with-back-btn>
</template>

<script>
import LayoutWithBackBtn from '@/views/pages/kompack/LayoutWithBackBtn.vue'
import { DAY_MONTH_YEAR_COMMA_TIME } from '@/libs/filterDate'
import StatusOrderPill from '../nonkomship/StatusOrderPill.vue'
import { statusMapping, MARKETPLACE_PLATFORM } from './config'
import DetailRow from './DetailRow.vue'
import DetailOrder from './DetailOrder.vue'
import ModalLoadingDownload from './ModalLoadingDownload.vue'

/**
 * Component untuk menampilkan detail fulfillment marketplace
 * @component Page
 */
export default {
  components: {
    LayoutWithBackBtn,
    StatusOrderPill,
    DetailRow,
    DetailOrder,
    ModalLoadingDownload,
  },
  data() {
    return {
      loading: true,
      isError: false,
      isPrintingOrder: false,
      data: {},
      statusMapping,
    }
  },
  computed: {
    marketplaceLogo() {
      return (
        MARKETPLACE_PLATFORM[this.data.marketplace]?.logo
        || MARKETPLACE_PLATFORM.kompack.logo
      )
    },
    pickupDeadline() {
      if (!this.data.pickup_deadline) return '-'
      return DAY_MONTH_YEAR_COMMA_TIME(this.data.pickup_deadline)
    },
  },
  mounted() {
    this.fnFetchData()
  },
  methods: {
    async fnFetchData() {
      try {
        const { data } = await this.$http_new.get(
          `/komship/api/v1/admin/marketplace-orders/${this.$route.params.id}/details`,
        )
        this.data = data.data
      } catch (error) {
        this.isError = true
      }
      this.loading = false
    },
    async requestPrintOrder() {
      this.isPrintingOrder = true
      if (!Number(this.$route.params.id)) {
        this.$toast_error({ message: 'Order tidak ditemukan' })
        this.isPrintingOrder = false
        return
      }
      this.$refs.modalLoadingDownload.showModal()
      try {
        const { data } = await this.$http_new.post(
          `/label/api/v1/admin/marketplace-labels/orders/${this.$route.params.id}`,
          null,
          {
            responseType: 'blob',
          },
        )

        // if the response is a JSON, then we can show the error message
        if (data && data.type && data.type.includes('application/json')) {
          this.$toast_error({
            message: 'Gagal mencetak order, silahkan coba lagi',
          })
          return
        }

        // if the response is a blob, then we can download the file
        if (data instanceof Blob) {
          const fileName = `${this.data.marketplace_order_id}-marketplace-order-${new Date()
            .toISOString()
            .slice(0, 10)}.pdf`
          const url = window.URL.createObjectURL(data)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
          this.$toast_success({
            message: 'Order berhasil dicetak ke perangkat Anda.',
            title: 'Cetak Order Berhasil',
          })
        } else {
          this.$toast_error({
            message: 'Gagal mencetak order, silahkan coba lagi',
          })
        }
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mencetak order, silahkan coba lagi',
        })
      } finally {
        this.isPrintingOrder = false
        this.$refs.modalLoadingDownload.closeModal()
      }
    },
  },
}
</script>
